"use client";

import { useActionState } from "react";
import { signUpAction } from "@/app/(auth)/actions";

/*
 * The client account form, on the marketing page.
 *
 * I originally linked to /signup instead of building this, reasoning that two
 * registration forms are two things to keep in step. That was my call to make
 * and I should have said so rather than quietly shipping a button — the design
 * puts a real form here, and asking someone to click through to a form is a
 * step where the design asks for none.
 *
 * It is not a second registration path: this posts to the SAME server action
 * /signup does, so validation, verification and the account it creates are one
 * implementation with two entry points.
 */
export function RegisterForm() {
  const [state, action, pending] = useActionState(signUpAction, {});

  return (
    <form action={action} style={{ display: "grid", gap: 14 }}>
      {state.error && (
        <p role="alert" style={{
          fontSize: 12.5, margin: 0, padding: "7px 9px",
          color: "var(--color-danger-900)", background: "var(--color-danger-100)",
          border: "1px solid var(--color-danger-500)",
        }}>{state.error}</p>
      )}

      <div style={{ display: "grid", gap: 14, gridTemplateColumns: "repeat(auto-fit, minmax(max(calc(50% - 7px), 140px), 1fr))" }}>
        <div className="field">
          <label htmlFor="rg-name">Name</label>
          <input id="rg-name" name="name" className="input" type="text"
                 autoComplete="name" placeholder="Jane Byrne" required />
        </div>
        <div className="field">
          <label htmlFor="rg-company">Company</label>
          <input id="rg-company" name="company" className="input" type="text"
                 autoComplete="organization" placeholder="Byrne Logistics" />
        </div>
      </div>

      <div className="field">
        <label htmlFor="rg-email">Work email</label>
        <input id="rg-email" name="email" className="input" type="email"
               autoComplete="email" placeholder="jane@byrnelogistics.ie" required />
      </div>

      <div className="field">
        <label htmlFor="rg-password">Choose a password</label>
        <input id="rg-password" name="password" className="input" type="password"
               autoComplete="new-password" required />
      </div>

      <div className="field">
        <label htmlFor="rg-why">What made you look into this?</label>
        <textarea id="rg-why" name="why" className="input" style={{ minHeight: 92 }}
                  placeholder="Two lines is plenty — what eats the week, or what you want to build." />
      </div>

      <button type="submit" className="btn btn-primary btn-block blueprint" disabled={pending}
              style={{ padding: "14px 24px", fontSize: 16 }}>
        <i className="corner tl" aria-hidden="true" /><i className="corner tr" aria-hidden="true" />
        <i className="corner bl" aria-hidden="true" /><i className="corner br" aria-hidden="true" />
        {pending ? "Creating…" : "Create your account"}
      </button>
    </form>
  );
}
